
import { Component, Vue, Prop } from 'vue-property-decorator'

    @Component({
      name: 'Tooltip'
    })
export default class Tooltip extends Vue {
  // #region Props

        @Prop({ default: '' }) text!: string;
        @Prop({ default: 'left' }) position!: 'top' | 'left' | 'bottom' | 'right';
        @Prop({ default: 'info' }) type!: 'info' | 'warning' | 'danger' | 'success';

        // #endregion

        // #region Computed

        get tooltipColout () {
          return 'tooltip--' + this.type
        }

        get tooltipClass () {
          return 'tooltiptext--' + this.position + ' tooltip--' + this.type
        }

        get flexClass () {
          const style: CSSStyleDeclaration = {} as CSSStyleDeclaration

          if (this.position === 'right' || this.position === 'left') {
            style.display = 'flex',
            style.alignItems = 'center'
          }

          return style
        }

  // #endregion
}
